import { render } from "./Network.vue?vue&type=template&id=2f37bf80&scoped=true"
import script from "./Network.vue?vue&type=script&lang=js"
export * from "./Network.vue?vue&type=script&lang=js"

import "./Network.vue?vue&type=style&index=0&id=2f37bf80&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f37bf80"]])

export default __exports__